import React, { Component, useState } from "react";
import review1 from "../../../assets/images/review1.png"
import { Rating } from 'react-simple-star-rating'

const Agent_review = () => {
    const [ratingValue, setRatingValue] = useState(0) // initial rating v

    const handleRating = (rate) => {
        setRatingValue(rate)
    }
    // Catch Rating value
    const handleReset = () => {
        setRatingValue(4)
        // other logic
    }
    return (
        <div>
            <div className="review_section">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="review_wrap">
                                <div className="heading_wrap">
                                    <div className="left_area">
                                        <h1>Reviews</h1>
                                    </div>
                                    <div className="right_area">
                                        <button className="btn-primary-5" >Write a review</button>
                                    </div>
                                </div>

                                <div className="review_area">
                                    <div className="review_detail">
                                        <div className="left_area">
                                            <div className="image_area">
                                                <img src={review1} />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <div className="text_area ul">
                                                <h4>Neeru bajwa</h4>
                                                <div className="rating_area">
                                                    <Rating
                                                        ratingValue={ratingValue}
                                                        showTooltip={false}
                                                        initialValue={3.8}
                                                        readonly
                                                        tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                    />
                                                </div>
                                                <p>Lorem ipsum dolor sit amet, con sectetur adipiscing elit. Maecenas con sectetur
                                                    maximus est, vel tincidunt odio auctor nec. </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="review_detail">
                                        <div className="left_area">
                                            <div className="image_area">
                                                <img src={review1} />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <div className="text_area ul">
                                                <h4>Neeru bajwa</h4>
                                                <div className="rating_area">
                                                    <Rating
                                                        ratingValue={ratingValue}
                                                        showTooltip={false}
                                                        initialValue={3.8}
                                                        readonly
                                                        tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                    />
                                                </div>
                                                <p>Lorem ipsum dolor sit amet, con sectetur adipiscing elit. Maecenas con sectetur
                                                    maximus est, vel tincidunt odio auctor nec. </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="review_detail">
                                        <div className="left_area">
                                            <div className="image_area">
                                                <img src={review1} />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <div className="text_area ul">
                                                <h4>Neeru bajwa</h4>
                                                <div className="rating_area">
                                                    <Rating
                                                        ratingValue={ratingValue}
                                                        showTooltip={false}
                                                        initialValue={3.8}
                                                        readonly
                                                        tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                    />
                                                </div>
                                                <p>Lorem ipsum dolor sit amet, con sectetur adipiscing elit. Maecenas con sectetur
                                                    maximus est, vel tincidunt odio auctor nec. </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="review_detail">
                                        <div className="left_area">
                                            <div className="image_area">
                                                <img src={review1} />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <div className="text_area ul">
                                                <h4>Neeru bajwa</h4>
                                                <div className="rating_area">
                                                    <Rating
                                                        ratingValue={ratingValue}
                                                        showTooltip={false}
                                                        initialValue={3.8}
                                                        readonly
                                                        tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                    />
                                                </div>
                                                <p>Lorem ipsum dolor sit amet, con sectetur adipiscing elit. Maecenas con sectetur
                                                    maximus est, vel tincidunt odio auctor nec. </p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Agent_review;
